export default __webpack_public_path__ + "static/media/KLIA.ff15b045.jpg";